<div class="language-selector" [class.theme-dark]="theme === 'dark'">
  <button class="language-btn" (click)="toggleDropdown()" type="button">
    <!-- <span class="flag">{{ getCurrentLanguage()?.flag }}</span> -->
    <span class="language-name">{{ getCurrentLanguage()?.name }}</span>
    <svg 
      class="dropdown-icon" 
      [class.open]="isDropdownOpen"
      xmlns="http://www.w3.org/2000/svg" 
      width="16" 
      height="16" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      stroke-width="2">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>

  <div class="language-dropdown" *ngIf="isDropdownOpen">
    <button 
      *ngFor="let language of languages" 
      class="language-option"
      [class.active]="language.code === currentLanguage"
      (click)="selectLanguage(language.code)"
      type="button">
      <!-- <span class="flag">{{ language.flag }}</span> -->
      <span class="language-name">{{ language.name }}</span>
      <svg 
        *ngIf="language.code === currentLanguage"
        class="check-icon"
        xmlns="http://www.w3.org/2000/svg" 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </button>
  </div>
</div>

<!-- Backdrop to close dropdown when clicking outside -->
<div class="dropdown-backdrop" *ngIf="isDropdownOpen" (click)="toggleDropdown()"></div>
